import type {
  AllHotels,
  DestinationConstraint,
  FullTextConstraint,
  HotelCodeConstraint,
  HotelSelection,
  PolygonConstraint,
  PolygonIdConstraint,
  ThemeConstraint,
} from './hotelConstraint';
import { SelectionPrefix } from './selectionPrefix';

export function isThemeConstraint(
  selection: HotelSelection
): selection is ThemeConstraint {
  return selection.prefix === SelectionPrefix.Theme;
}

export function isDestinationConstraint(
  selection: HotelSelection
): selection is DestinationConstraint {
  return selection.prefix === SelectionPrefix.Destination;
}

export function isPolygonConstraint(
  selection: HotelSelection
): selection is PolygonConstraint {
  return selection.prefix === SelectionPrefix.Polygon;
}

export function isPolygonIdConstraint(
  selection: HotelSelection
): selection is PolygonIdConstraint {
  return selection.prefix === SelectionPrefix.PolygonId;
}

export function isHotelCodeConstraint(
  selection: HotelSelection
): selection is HotelCodeConstraint {
  return selection.prefix === SelectionPrefix.HotelCode;
}

export function isFullTextConstraint(
  selection: HotelSelection
): selection is FullTextConstraint {
  return selection.prefix === SelectionPrefix.FullText;
}

export function isAllHotelsConstraint(
  selection: HotelSelection
): selection is AllHotels {
  return selection.prefix === SelectionPrefix.AllHotels;
}
